
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 23"}},[_c('path',{attrs:{"d":"M9.969 5.258C9.789 2.495 12.027.223 14.603 0c.354 3.186-2.896 5.57-4.634 5.258zm6.215 16.107c-1.207 1.17-2.54.989-3.81.436-1.35-.563-2.583-.6-4.01 0-1.775.767-2.717.544-3.786-.436C-1.462 15.149-.57 5.68 6.293 5.325c1.664.089 2.83.92 3.81.989 1.457-.297 2.85-1.146 4.41-1.034 1.874.15 3.276.89 4.21 2.22-3.853 2.318-2.94 7.397.6 8.823-.708 1.86-1.617 3.698-3.141 5.057l.002-.015z","fill":"#FFF"}})])
      }
    
      }
    